import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
const TimelineItem = function TimelineItem(props) {
    const { prefixCls: customizePrefixCls, className, color = '', children, pending, dot, ...restProps } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('timeline', customizePrefixCls);
    const itemClassName = classNames({
        [`${prefixCls}-item`]: true,
        [`${prefixCls}-item-pending`]: pending,
    }, className);
    const dotClassName = classNames({
        [`${prefixCls}-item-head`]: true,
        [`${prefixCls}-item-head-custom`]: dot,
        [`${prefixCls}-item-head-${color}`]: true,
    });
    const customColor = /blue|red|green/.test(color) ? undefined : color;
    return (React.createElement("li", Object.assign({}, restProps, { className: itemClassName }),
        React.createElement("div", { className: `${prefixCls}-item-tail` }),
        React.createElement("div", { className: dotClassName, style: { borderColor: customColor, color: customColor } }, dot),
        React.createElement("div", { className: `${prefixCls}-item-content` }, children)));
};
TimelineItem.displayName = 'TimelineItem';
TimelineItem.defaultProps = {
    color: 'blue',
    pending: false,
};
export default TimelineItem;
